export const env = {
  REACT_APP_EMAILJS_RECEIVER: process.env.REACT_APP_EMAILJS_RECEIVER,
  REACT_APP_EMAILJS_TEMPLATEID: process.env.REACT_APP_EMAILJS_TEMPLATEID,
  REACT_APP_EMAILJS_USERID: process.env.REACT_APP_EMAILJS_USERID
};
